import { makeStyles } from '@material-ui/core'

export const useStyles = makeStyles(theme => ({
  dialog: {
    width: "500px"
  },
  dialogTitle:{
    color: theme.palette.blue_300.main
  },
  radio: {
    '&.MuiRadio-root': {
      color: theme.palette.blue_300.main,
      padding: 0,
      marginRight: 4,
    },
    '& .MuiSvgIcon-root': {
      fontSize: 18
    },
    '&.Mui-checked': {
      color: theme.palette.blue_300.main
    }
  }
}))